/* @flow */
import React from 'react';
import classnames from 'classnames';

export type ImageType = {
  src?: string,
  alt?: string,
  title?: string,
  width: number,
  height: number,
  lazyload?: boolean,
  cover?: boolean,
  decorative?: boolean,
  srcPlaceholder?: boolean,
};

const Image = ({
  src,
  alt,
  title,
  width,
  height,
  lazyload = true,
  cover = false,
  decorative = false,
  srcPlaceholder = true,
}: ImageType): React$Element<"div"> => {
  const showPadding = !cover && width && height;
  let imageSrc = src;
  if (!src && srcPlaceholder) {
    imageSrc = `https://via.placeholder.com/${width}x${height}/F5F5F5/28281a}.png?text=${width}x${height}`;
  }

  return (
    <div
      className={classnames({
        image: true,
        'image--cover': cover,
        loading: lazyload,
      })}
      style={
        showPadding && {
          paddingTop: `${(height / width) * 100}%`,
        }
      }
    >
      {lazyload && (
        <noscript>
          <img
            className="image__fallback"
            alt={alt}
            height={height}
            width={width}
            role={decorative ? 'presentation' : ''}
            src={imageSrc}
            title={title}
          />
        </noscript>
      )}
      <img
        className={classnames({
          image__img: true,
          'js-lazyload': lazyload,
        })}
        src={!lazyload ? imageSrc : null}
        data-src={lazyload ? imageSrc : null}
        width={width}
        height={height}
        alt={alt}
        role={decorative ? 'presentation' : null}
        title={title}
      />
    </div>
  );
};

export default Image;
